import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="container">
      <div className="notFound">
        <Link to="/">
          <img src="/assets/images/404.png" width="100%" alt="" />
        </Link>
        <h2>Oops! Nothing was found</h2>
        <p>
          The page you are looking for might have been removed had its name
          changed or is temporarily unavailable.
        </p>
        <Link to="/">{"Return To Homepage"}</Link>
      </div>
    </div>
  );
};

export default NotFound;
